import { 
    CONTRACT_SPECIFICATION_GET_REQUEST, CONTRACT_SPECIFICATION_GET_SUCCESS, CONTRACT_SPECIFICATION_GET_ERROR, 
    CONTRACT_SPECIFICATION_GET_BY_KEY_REQUEST, CONTRACT_SPECIFICATION_GET_BY_KEY_SUCCESS, CONTRACT_SPECIFICATION_GET_BY_KEY_ERROR, 
    CONTRACT_SPECIFICATION_ADD_REQUEST, CONTRACT_SPECIFICATION_ADD_SUCCESS, CONTRACT_SPECIFICATION_ADD_ERROR, 
    CONTRACT_SPECIFICATION_EDIT_REQUEST, CONTRACT_SPECIFICATION_EDIT_SUCCESS, CONTRACT_SPECIFICATION_EDIT_ERROR, 
    CONTRACT_SPECIFICATION_DELETE_REQUEST, CONTRACT_SPECIFICATION_DELETE_SUCCESS, CONTRACT_SPECIFICATION_DELETE_ERROR
} from "../constants/contractSpecificationConstants";

const initialState = {
    contractSpecifications: [],
    contractSpecification: {},
    loading: false,
    success: null,
    error: null,
    contractSpecificationRequestedCount: 0,
};

export const contractSpecificationReducer = (state = initialState, action) => {
    switch (action.type)     {
        case CONTRACT_SPECIFICATION_GET_REQUEST:
            return {
                ...state,
                contractSpecificationRequestedCount: ++state.contractSpecificationRequestedCount,
                loading: true,
            };
        case CONTRACT_SPECIFICATION_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                contractSpecifications: action.payload,
                success: true,
            };
        case CONTRACT_SPECIFICATION_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_SPECIFICATION_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_SPECIFICATION_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                contractSpecification: action.payload,
                success: true,
            };
        case CONTRACT_SPECIFICATION_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_SPECIFICATION_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_SPECIFICATION_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_SPECIFICATION_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_SPECIFICATION_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_SPECIFICATION_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_SPECIFICATION_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_SPECIFICATION_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_SPECIFICATION_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_SPECIFICATION_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
